// NPM Imports
import React, { useContext, useEffect } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
import { productType } from '../../../types/types'
// JS Imports
// Asset Imports
import { MultiProductTable } from '../../ui-helper-elements'

export default function TimeClocksShippingTable() {
   //TODO: change this to the proper typing once we migrate App.jsx to Typescript
   const state = useQuoteContext()
   const { getString } = state
   const permissions = state.featurePermissions['TimeClocks']

   const clockList = (Object.values(state.product_list) as productType[])
      .filter(
         (product) =>
            product.ProductFamily === 'Time Clocks Shipping' &&
            product.BillingFreq === 'once',
      )
      .sort(
         (a: productType, b: productType) =>
            (a.DisplayOrder ?? 0) - (b.DisplayOrder ?? 0),
      )

   if (!state.productHasTimeClocks) return <></>

   if (
      (permissions.includes(state.user_role) || state.productHasTimeClocks) &&
      state.product_list['clockMonthlySupport']
   ) {
      return (
         <MultiProductTable
            title={getString('product.TimeClocksShippingTable.TableTitle')}
            productList={clockList}
            detailsList={state.productTimeClockDetails}
            setDetailsList={state.setProductTimeClockDetails}
            handleDetailsChange={(updatedList) =>
               state.setProductTimeClockDetails(updatedList)
            }
            codeField='shippingClockCode'
            currencyObject={state.currencyObject}
         />
      )
   }
}
